export default {
  common: {
    documentTitle: 'iOS Sub',
    back: '← Back',
    backHome: '← Back to Home',
    loading: 'Loading...',
    submitting: 'Submitting...',
    querying: 'Querying...',
    retry: 'Search Again',
    selectPlaceholder: 'Select',
  },
  language: {
    switchToEnglish: 'Switch to English',
    switchToChinese: 'Switch to Chinese',
  },
  theme: {
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
  },
  home: {
    brand: 'iOS Sub',
    topLabel: '',
    brandSub: '',
    heroTitle: 'ChatGPT iOS Self-Service Activation',
    heroSub: 'Enter the redemption code and submit the Session, and the recharge will be completed automatically.',
    trust: { official: 'Independent channel', fast: 'Fast verification', trackable: 'Order lookup' },
    flowTitle: 'How It Works',
    tabsAria: 'Recharge portal sections',
    announcementLabel: 'Notice',
    announcementAria: 'Recharge page announcement',
    services: {
      recharge: { title: 'Recharge', en: 'Service Portal', cta: 'Start Recharge', p1: 'Verify CDK code', p2: 'Submit session', p3: 'Confirm submission' },
      lookup: { title: 'Task Lookup', en: 'Task Lookup', cta: 'Check Status', p1: 'Look up by CDK', p2: 'View task status', p3: 'Track progress' },
    },
    flows: {
      submit: { title: 'Submit Flow', s1: 'Verify CDK — match plan and status', s2: 'Submit session — paste the JSON from chatgpt.com/api/auth/session', s3: 'Confirm and submit' },
      lookup: { title: 'Lookup Flow', s1: 'Enter CDK — the code used at purchase', s2: 'Query task — click the search button', s3: 'View status — see the matching task status' },
    },
  },
  queue: {
    pendingLabel: 'Stock',
    unit: 'codes',
    loading: 'Syncing',
    syncing: 'Live stock',
    reconnecting: 'Stock synced',
  },
  recharge: {
    title: 'Redeem Now',
    subtitle: 'ChatGPT account self-service upgrade',
    steps: { s1: 'Verify Code', s2: 'Submit Session', s3: 'Confirm' },
    overline: 'Complete recharge step by step',
    cardTitle: 'Redemption Code Recharge',
    cardHint: '',
    readyBadge: 'Awaiting verification',
    step1Title: 'Enter redemption code',
    codePlaceholder: 'Enter an LZ-, LZ5X- or LZ20X- code',
    cdkLabel: 'Redemption Code',
    cdkValid: '✓ Code valid',
    cdkPending: 'This redemption code is being processed',
    cdkPendingHint: 'Auto-checking… if the task fails it will become submittable again automatically, no refresh needed',
    planType: 'Plan Type',
    verifying: 'Verifying...',
    verifyButton: 'Verify Code',
    safeHint: '',
    next: 'Next →',
    prev: '← Previous',
    restart: 'Start Over',
    step2Title: 'Submit Session',
    progressAria: 'Recharge progress',
    sessionGuidePrefix: 'After logging into ChatGPT, open in your browser',
    sessionGuideSuffix: ', copy the full JSON returned, and paste it into the box below.',
    sessionLabel: 'Session JSON',
    step3Title: 'Confirm & Submit',
    sessionStatus: 'Session Status',
    sessionFilled: '✓ Provided',
    submitSuccessTitle: '✓ Request submitted successfully!',
    taskId: 'Task ID',
    submitSuccessHint: 'You can track the progress on the "Task Lookup" page',
    confirmSubmit: 'Confirm & Submit',
    coverConfirmMessage: 'This account is currently a Plus/Pro member. Continuing will overwrite the original subscription time, and the remaining time cannot be preserved.\nContinue?',
    errInvalidCdk: 'Invalid redemption code',
    errExternalCdkOnly: 'Invalid code format',
    errVerifyFailed: 'Verification failed',
    errCreateFailed: 'Failed to create task',
    errConfirmFailed: 'Submission failed',
    errNetwork: 'Network error',
    errSessionRequired: 'Please paste the complete Session JSON',
    errSessionInvalidJson: 'Invalid Session JSON. Please copy and paste the complete JSON',
    errSessionMissingAccessToken: 'Incomplete Session JSON: accessToken was not found',
    errSessionMissingEmail: 'Incomplete Session JSON: account email was not found',
    errSessionMissingPlanType: 'Incomplete Session JSON: planType was not found',
    errSessionPlanNotFree: 'Current account planType is {planType}. You will be asked to confirm before overwriting it',
  },
  history: {
    title: 'Order Lookup',
    subtitle: 'Check your order status with a redemption code',
    queryTitle: 'Redemption Code Lookup',
    queryHint: 'Enter the redemption code from your purchase to view the matching order status.',
    queryPlaceholder: 'Enter the redemption code to look up',
    batchQueryTitle: 'Batch Code Lookup',
    batchQueryHint: 'Paste multiple redemption codes at once (up to 100), separated by new lines, spaces, commas, or semicolons. Duplicates are removed automatically.',
    batchQueryPlaceholder: 'One redemption code per line, or separate codes with commas',
    detectedCodes: '{count} unique redemption codes detected',
    clearQuery: 'Clear Query',
    cdkLabel: 'Redemption Code',
    queryBtn: 'Look Up Order',
    batchQueryBtn: 'Batch Query',
    queryErrorTitle: 'Query Failed',
    resultTitle: 'Result',
    liveRefreshing: 'Auto-refreshing in-progress tasks…',
    batchResultTitle: 'Batch Results',
    batchSummaryTitle: 'Lookup Overview',
    batchSummaryText: '{found}/{total} tasks found, {unused} unused.',
    batchSummaryTextWithMissing: '{found}/{total} tasks found, {unused} unused, {notFound} not found.',
    batchStatsAria: 'Batch lookup statistics',
    totalQueried: 'Total',
    foundCount: 'Found',
    processingCount: 'Processing',
    failedCount: 'Failed',
    unusedCount: 'Unused',
    notFoundCount: 'Not Found',
    batchListAria: 'Batch lookup result list',
    accountUnknown: 'Account not recorded',
    unusedShort: 'Unused',
    unusedHint: 'This redemption code has not been submitted for redemption',
    unusedWithPlan: 'No task submitted · {plan}',
    notFoundShort: 'Not Found',
    copyUnused: 'Copy Unused',
    copyUnusedSuccess: 'Copied {count} unused CDKs.',
    copyUnusedFailed: 'Copy failed. Please copy manually.',
    maxBatchExceeded: 'You can query up to {max} CDKs at a time. Please split the list and try again.',
    taskId: 'Task ID',
    cdkCode: 'Redemption Code',
    subscriptionType: 'ChatGPT Plan',
    rechargeAccount: 'Recharge Account',
    currentStatus: 'Current Status',
    failureReason: 'Failure Reason',
    detailTitle: 'Task Details',
    submitTime: 'Submitted At',
    completeTime: 'Completed At',
    queryOther: 'Query Another Task',
    detailActionsAria: 'Task actions',
    copyCdk: 'Copy Code',
    copyAccount: 'Copy Account',
    resubmit: 'Resubmit',
    copyCdkSuccess: 'Redemption code copied',
    copyAccountSuccess: 'Account copied',
    copyActionFailed: 'Copy failed. Please copy manually.',
    selectTaskTitle: 'Select a task to view details',
    selectTaskHint: 'Click any found task on the left to see its full details here.',
    notFoundTitle: 'No order found for this redemption code',
    notFoundHint: 'Please check whether the redemption code is correct',
    msgPending: '⏳ Task is waiting to be processed, please wait...',
    msgSubmitted: '⚙ Task is being processed, please wait...',
    msgManualReview: '⏳ Manual handling is in progress. Please wait...',
    msgCompleted: '✓ Task completed, your account has been upgraded',
    msgFailed: '✗ Task failed, please resubmit or contact support',
    resultHeadline: { pending: 'Waiting for Confirmation', submitted: 'Processing in Console', manual_review: 'Manual Handling', completed: 'Recharge Completed', failed: 'Recharge Failed' },
    status: { pending: 'Pending', submitted: 'Processing', manual_review: 'Manual Handling', completed: 'Completed', failed: 'Failed' },
  },
  subscription: {
    title: 'Subscription',
    inputLabel: 'Enter Session',
    inputPlaceholder: 'Paste the full JSON from chatgpt.com/api/auth/session, or an accessToken directly',
    inputHint: 'Used only to check the subscription status in real time; your session is never stored. Full session JSON or accessToken both work.',
    queryBtn: 'Check Subscription',
    clear: 'Clear',
    queryErrorTitle: 'Query Failed',
    queryFailed: 'Subscription lookup failed, please try again',
    errInvalidInput: 'Invalid session format. Paste the full session JSON or a bare accessToken.',
    errInvalidSession: 'Session is invalid or expired. Please get a fresh one and retry.',
    errRateLimited: 'Too many requests, please try again shortly.',
    resultTitle: 'Subscription',
    statusActive: 'Active subscription with auto-renewal on',
    statusCancelling: 'Active subscription, but auto-renewal is off',
    statusInactive: 'No active subscription on this account',
    badgeActive: 'Active',
    badgeInactive: 'None',
    cancelledNotice: 'Auto-renewal is off. The subscription will stop at the end of the current period with no further charges.',
    willRenewNotice: 'Auto-renewal is on. You will be charged again on {date}.',
    inactiveNotice: 'This account has no active subscription.',
    yes: 'Yes',
    no: 'No',
    renewOn: 'On',
    renewOff: 'Off',
    planFree: 'Free',
    detailTitle: 'Details',
    fieldAccount: 'Account',
    fieldPlan: 'Plan',
    fieldActive: 'Active',
    fieldWillRenew: 'Auto-renew',
    fieldExpires: 'Expires',
    fieldRenews: 'Renews',
    fieldCancels: 'Cancels at',
    fieldBillingPeriod: 'Billing period',
    fieldPlatform: 'Purchase platform',
    periodMonthly: 'Monthly',
    periodYearly: 'Yearly',
    periodWeekly: 'Weekly',
    platformWeb: 'ChatGPT Web',
    platformIos: 'iOS (App Store)',
    platformGoogle: 'Android (Google Play)',
  },
  login: {
    title: 'Admin Login',
    subtitle: 'Log in to access the admin console, CDK management and task processing.',
    username: 'Username',
    usernamePlaceholder: 'Enter username',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    rememberPassword: 'Remember password',
    rememberPasswordHint: 'Saved only in this browser and cleared when unchecked',
    loginBtn: 'Sign In',
    loggingIn: 'Signing in...',
    errLoginFailed: 'Login failed',
    errNetwork: 'Network error, please try again later',
  },
  notFound: {
    title: 'Page Not Found',
    home: 'Back to Home',
  },
}
